'use client';

import AppImage from '@/components/ui/AppImage';


export default function PromoBanner() {
  return (
    <div className="bg-gradient-to-r from-red-500 to-red-600 py-3 px-6">
      <div className="max-w-7xl mx-auto flex items-center justify-between gap-4">
        {/* Left Side - Logo, Name, and Tagline */}
        <div className="flex items-center gap-3">
          <AppImage
            src="/assets/images/intagg_logo-01-1770559550357.png"
            alt="Intaggs logo"
            width={40}
            height={40}
            className="rounded-md bg-white p-1"
          />
          <div className="flex flex-col">
            <h2 className="font-heading font-bold text-xl text-white leading-tight">intaggs</h2>
            <p className="text-xs text-white/90 leading-tight">news in 100 words</p>
          </div>
        </div>

        {/* Center - Promotional Text */}
        <div className="hidden md:block flex-1 text-center">
          <p className="text-white text-sm md:text-base font-medium">
            For the best experience use <span className="font-bold">intaggs</span> app on your smartphone
          </p>
        </div>

        {/* Right Side - App Store Buttons */}
        <div className="flex items-center gap-3">
          <button
            disabled
            className="flex items-center gap-2 bg-black text-white px-3 py-2 rounded-lg hover:bg-gray-800 transition-all opacity-50 cursor-not-allowed"
            aria-label="Download on the App Store"
          >
            <svg className="w-6 h-6" viewBox="0 0 24 24" fill="currentColor">
              <path d="M18.71 19.5c-.83 1.24-1.71 2.45-3.05 2.47-1.34.03-1.77-.79-3.29-.79-1.53 0-2 .77-3.27.82-1.31.05-2.3-1.32-3.14-2.53C4.25 17 2.94 12.45 4.7 9.39c.87-1.52 2.43-2.48 4.12-2.51 1.28-.02 2.5.87 3.29.87.78 0 2.26-1.07 3.81-.91.65.03 2.47.26 3.64 1.98-.09.06-2.17 1.28-2.15 3.81.03 3.02 2.65 4.03 2.68 4.04-.03.07-.42 1.44-1.38 2.83M13 3.5c.73-.83 1.94-1.46 2.94-1.5.13 1.17-.34 2.35-1.04 3.19-.69.85-1.83 1.51-2.95 1.42-.15-1.15.41-2.35 1.05-3.11z"/>
            </svg>
            <span className="text-xs font-semibold hidden sm:inline">App Store</span>
          </button>
          <button
            disabled
            className="flex items-center gap-2 bg-black text-white px-3 py-2 rounded-lg hover:bg-gray-800 transition-all opacity-50 cursor-not-allowed"
            aria-label="Get it on Google Play"
          >
            <svg className="w-6 h-6" viewBox="0 0 24 24" fill="currentColor">
              <path d="M3,20.5V3.5C3,2.91 3.34,2.39 3.84,2.15L13.69,12L3.84,21.85C3.34,21.6 3,21.09 3,20.5M16.81,15.12L6.05,21.34L14.54,12.85L16.81,15.12M20.16,10.81C20.5,11.08 20.75,11.5 20.75,12C20.75,12.5 20.53,12.9 20.18,13.18L17.89,14.5L15.39,12L17.89,9.5L20.16,10.81M6.05,2.66L16.81,8.88L14.54,11.15L6.05,2.66Z"/>
            </svg>
            <span className="text-xs font-semibold hidden sm:inline">Google Play</span>
          </button>
        </div>
      </div>

      {/* Mobile - Promotional Text */}
      <div className="md:hidden mt-2 text-center">
        <p className="text-white text-xs font-medium">
          For the best experience use <span className="font-bold">intaggs</span> app on your smartphone
        </p>
      </div>
    </div>
  );
}